import Login from "@/modules/auth/views/login/Login.vue";
import CreateAccount from "@/modules/auth/views/create-account/CreateAccount.vue";
import PasswordReset from "@/modules/auth/views/recovery/PasswordReset";

export default [
  {
    path: "/login",
    component: Login,
    name: "login",
    meta: { title: "Login" },
  },
  {
    path: "/register",
    component: CreateAccount,
    name: "register",
    meta: { title: "Create Account" },
  },
  {
    path: "/recovery",
    component: PasswordReset,
    name: "recovery",
    meta: { title: "Password Reset" },
  },
];
